export default {
    goodsClassify: {
        page: {
            SearchCategory: '搜索分类',
            AllCategories: '所有分类',
            CategoryType: '类目类型',
            ParentClass: '所属父类',
            AddCategory: '新增分类',
        },
        table: {
            ClassificationName: '分类名称',
            ClassificationCode: '分类编码',
            ParentClass: '所属父类',
            Type: '类型',
            bindingAttributes: '绑定属性数量',
            Remarks: '备注',

            // GoodsAttributeList
            Attributename: '属性名称',
            Attributecode: '属性编码',
            Attributemethod: '表单方式',
            Attributevalue: '属性值',
            AttributeType: '属性类型',
            Attributesource: '属性来源',
            AttributeSKU: '是否生成SKU',
            DragSort: '拖拽排序',
        },
        dialog: {
            CEN: '中文/英文/数字',
            lettersNumbers: '0-20个英文字母、数字',
            ParentClassification: '父级分类',
            LeafNode: '是否叶子结点',
            WhenLeafNode: '当设为叶子结点时，无法添加子分类，商品挂载在叶子结点',
            Remarks: '备注',
            category: '请选择所属分类',
            EditClassification: '编辑分类',
            CreateCategory: '新建分类',
        },
        common: {
            ClassificationName: '分类名称',
            ClassificationCode: '分类编码',
        },
        dialogTable: {
            titleName: '属性表',
            attributes: '导入分类属性',
            superior: '复制上级属性',
            AddAttribute: '添加属性',
            EditAttribute: '编辑属性',
            BasicInformation: '基础信息',
            Presentation: '展示方式',
            corresponding: '内容展示方式为单选框、复选框、下拉框时，需要添加对应的属性值。',
            GenerateSKU: '生成SKU',
            InformationContent: '信息内容',
            AlreadyExists: '已存在，请重新设置'
        }
    }
};
